/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import get from 'lodash/get';

import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config';

export const configHelper = {
  /**
   * @private
   *
   * @type {object} The application configuration object
   */
  config: null,

  /**
   * Gets the value at path of config object
   *
   * @param {string|string[]} [path] The path of the property to get
   *
   * @returns {any} The configuration value
   */
  getConfig(path = null) {
    if (!this.config) {
      this.config = getConfig();
    }

    return get(this.config, path);
  },

  /**
   * Gets the proxy host for the given path
   *
   * @param {string} path The proxy path
   *
   * @returns {string} The proxy host that match the given path
   */
  getProxyHost(path = 'api') {
    const proxy = this.getConfig('ssrParameters.proxyConfigs').find((proxy) => proxy.path === path);

    return proxy ? proxy.host : null;
  },
};
